import { INodePropCfg, getNodeProps } from '@intelligence/utils/domUtils';

const childProps: INodePropCfg[] = [
  { name: 'width', type: 'number' },
  { name: 'padding-left', type: 'number' },
  { name: 'padding-right', type: 'number' },
  { name: 'margin-left', type: 'number' },
  { name: 'margin-right', type: 'number' },
];
export const getChildrenWidth = (node?: HTMLElement | null): number => {
  const children = node?.children;
  if (!children?.length) return 0;
  let totalWidth = 0;
  for (const child of children) {
    const {
      width,
      'margin-left': marginLeft,
      'margin-right': marginRight,
      'padding-left': paddingLeft,
      'padding-right': paddingRight,
    } = getNodeProps(child, childProps);
    totalWidth =
      totalWidth +
      (width as number) +
      (marginLeft as number) +
      (marginRight as number) +
      (paddingLeft as number) +
      (paddingRight as number);
  }
  return totalWidth;
};

export const getIsOverflow = (containerWidth: number, listWidth: number, offset = 0): boolean => {
  if (offset) return listWidth - containerWidth > offset;
  return listWidth > containerWidth;
};
